import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React from 'react'
import '../../css/common.css'
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';

function Delete(props) {
  return (
    <Dialog
		open={props.openDelete}
		onClose={props.closeDelete}
		aria-labelledby="responsive-dialog-title"
	>
		<DialogTitle id="responsive-dialog-title" sx={{width: '350px', fontWeight: 600}}>
			<ErrorOutlineRoundedIcon sx={{pr:1, verticalAlign: "-4px"}}/>삭제 경고
		</DialogTitle>
		<DialogContent>
			<DialogContentText sx={{fontWeight: 600, m:"15px 0px 0px 10px"}}>
				삭제한 데이터는 다시 되돌릴 수 없습니다. <br/>
				정말 삭제하시겠습니까?
			</DialogContentText>
		</DialogContent>
		<DialogActions sx={{p: "8px 20px 10px 8px"}}>
			<Button onClick={props.closeDelete} variant="outlined">
				취소
			</Button>
			<Button onClick={props.onClickDelete} variant="outlined">
				확인
			</Button>
		</DialogActions>
	</Dialog>
  )
}

export default Delete